import Vue from "vue";

class commaClass {

    fn(value, num) {

        if (_.trim(value) == '') value = '0';
        if (typeof value == 'string') value = value.replace(/,/g, '');

        let decimalLen = _.isNil(num) || num < 0 ? 2 : num;

        if (_.isNaN(parseFloat(value))) value = '0';
            
        return _.round(Number(value), decimalLen).toLocaleString('en-US', { minimumFractionDigits: decimalLen });
    }

    init() {
        let self = this;

        Vue.filter('comma', function (value, num) {
            return self.fn(value, _.isNil(num) || num < 0 ? 2 : num);
        });

        Vue.directive('comma', {
            bind: function (el, binding) {

                var handler = function () {
                    if (el.value != el.oldValue) {

                        let num = _.isNil(binding.value) || binding.value < 0 ? 2 : binding.value;
                        el.value = self.fn(el.value, num);

                        var event = document.createEvent('Event');
                        event.initEvent('input', true, true);
                        el.dispatchEvent(event);

                    }
                };
                el.commaHandler = handler;
                el.addEventListener('change', handler);

                handler();
            }
        });
    }
}
new commaClass().init();



// WEBPACK FOOTER //
// ./src/helpers/comma.js